import { createBridgeClient } from '@ps/common-features/lib/api/config/clientBridge'
import i18n from 'i18next'
import { getCurrentLanguage } from 'src/utils/locale/getCurrentLanguage'

import { BASE_URL, BRIDGE_API_KEY, BRIDGE_BASE_URL } from './constants'

export const apiClientBridge = createBridgeClient(BASE_URL, BRIDGE_BASE_URL, BRIDGE_API_KEY, {
  skipAuthentication: true,
})

/**
 * Resident is currently the only portal with locales, so Accept-Language is attached here instead
 * of in the shared client factory and resolved per request to follow the active i18next language.
 */
apiClientBridge.interceptors.request.use((config) => {
  config.headers['Accept-Language'] = getCurrentLanguage(i18n)

  return config
})
